import { render, staticRenderFns } from "./PagesNewsletterWidget.vue?vue&type=template&id=5128f3b4&"
import script from "./PagesNewsletterWidget.vue?vue&type=script&lang=js&"
export * from "./PagesNewsletterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports